import { ISelectOption } from "@repo/core/components/core/Select";

export const reasonOptions: ISelectOption[] = [
  {
    label: "Aumento de Limite",
    value: "1"
  },
  {
    label: "Reavaliação da Proposta",
    value: "2"
  },
  {
    label: "Outros",
    value: "3"
  }
];
